import type { ArticleType } from './articles/api';

/**
 * Der Sprung in den Verfasser -- ausgeloest von einem Tastenkuerzel.
 *
 * Ein Ereignis und keine durchgereichte Eigenschaft: Der Verfasser liegt
 * zwei Ebenen unter der Ticketseite in einem Reiter. Ein Zustand dafuer
 * muesste durch beide Ebenen wandern, um an genau einer Stelle gebraucht zu
 * werden -- und jede Ebene dazwischen wuesste dann von etwas, das sie nichts
 * angeht.
 */
export interface ComposeRequest {
  articleType: ArticleType;
}

export const COMPOSE_EVENT = 'itscrm:compose';

/** Waehlt die Art des Beitrags und setzt den Schreibzeiger ins Textfeld. */
export function requestCompose(articleType: ArticleType): void {
  window.dispatchEvent(new CustomEvent<ComposeRequest>(COMPOSE_EVENT, { detail: { articleType } }));
}
